<template>
  <div class="global-product">
    <div class="product" :class="classModifier">
      <router-link
        v-if="
          product &&
          (classModifier === 'product--inline' || classModifier === 'product--inline product--inline-minimalist')
        "
        :to="$options.filters.productUrlReview(product)"
        :title="product.name"
        @click.native="trackProduct()"
      >
        <div class="layer-link"></div>
      </router-link>
      <button v-if="product.combinations" class="product__wishlist" @click.prevent="toggleWhishListV2">
        <img class="product__wishlist__img" :src="wishlistSrcUrlV2" :alt="product.name" />
      </button>
      <div v-if="labelDiscount" class="product__label-discount">
        {{ labelDiscount }}
      </div>
      <div class="product__thumb">
        <router-link
          :to="$options.filters.productUrlReview(product)"
          :title="product.name"
          @click.native="trackProduct()"
        >
          <img
            v-if="product.images && product.images.length && product.brand"
            class="product__img pro-thumb-img"
            :src="mainImage(imageCover.url)"
            loading="lazy"
            :alt="`${product.name}-${product.brand.name}`"
            onerror="this.src='/assets/img/dummy_product.svg'"
          />
          <img
            v-else-if="
              product.combinations &&
              product.combinations[0] &&
              product.combinations[0].images &&
              product.combinations[0].images[0] &&
              product.combinations[0].images[0].url
            "
            class="product__img pro-thumb-img"
            :src="mainImage(product.combinations[0].images[0].url)"
            loading="lazy"
            :alt="`${product.name}-${product.brand.name}`"
          />
          <img v-else class="product__img" src="/assets/img/dummy_product.svg" loading="lazy" alt="SOCO" />
        </router-link>
      </div>
      <div v-if="!hideCombinations" class="product__combinations">
        <!-- START::DOUBLE_COMBINATION -->
        <div v-if="isDoubleCombination" class="combination-label">More options available</div>
        <!-- END::DOUBLE_COMBINATION -->
        <template v-else>
          <template v-for="(comb, key) in combination">
            <!-- START::SHADE_COMBINATION -->
            <template v-if="key === 'shades' && comb.length">
              <div v-for="(shade, i) in comb.slice(0, 3)" :key="i" class="shade">
                <img
                  v-if="shade && shade.value && shade.value.startsWith('http')"
                  :src="shade.value"
                  :alt="shade.name"
                  :style="{ backgroundColor: shade.value, borderRadius: '50%' }"
                />
                <div v-else :style="{ backgroundColor: shade.value, borderRadius: '50%' }"></div>
              </div>
              <div v-if="comb.length - 3 > 0" :key="key">+{{ comb.length - 3 }}</div>
            </template>
            <!-- END::SHADE_COMBINATION -->
            <!-- START::SIZE_OR_VARIANT_COMBINATION -->
            <template v-else-if="comb.length">
              <div v-for="(sizeOrVariant, i) in comb.slice(0, 2)" :key="i" class="combination-label">
                {{ sizeOrVariant.name }}
              </div>
              <div v-if="comb.length - 2 > 0" :key="key">+{{ comb.length - 2 }}</div>
            </template>
            <!-- END::SIZE_OR_VARIANT_COMBINATION -->
          </template>
        </template>
      </div>
      <div v-if="!rightBtnReview" :class="{ 'btn-group-mobile': !isDesktop }">
        <a
          v-if="productExistsInSociolla && availableStock && isDesktop"
          target="_blank"
          rel="noopener"
          :href="productUrl(product)"
          class="btn btn-red product__button-review"
          @click="internalTrack('click', 'shop_now')"
        >
          <img src="/assets/img/icons/shop-action.svg" alt="shop now" />
          Shop now
        </a>
        <template v-else>
          <a
            v-if="totalReview"
            :href="$options.filters.productUrlReview(product)"
            class="btn btn-dark product__button-review"
            :class="[{ 'btn-mobile': !isDesktop }, { 'btn-red': !isDesktop }]"
          >
            See review
          </a>
          <a
            v-else
            href=""
            class="btn btn-dark product__button-review"
            :class="[{ 'btn-mobile': !isDesktop }, { 'btn-red': !isDesktop }]"
            @click.prevent="isLogin ? selectProduct('add', 'add_review') : addReviewUrl(product, 'add', 'add_review')"
          >
            Add review
          </a>
        </template>
        <a
          v-if="productExistsInSociolla && availableStock && !isDesktop"
          target="_blank"
          rel="noopener"
          :href="productUrl(product)"
          @click="internalTrack('click', 'shop_now')"
        >
          <img src="/assets/img/icons/shop-action-2.svg" alt="shop now" width="24" height="24" />
        </a>
      </div>
      <div class="product__info">
        <router-link
          v-if="product.brand"
          :to="$options.filters.productUrlReview(product)"
          :title="product.name"
          class="product__brand"
          @click.native="trackProduct()"
          >{{ product.brand.name }}</router-link
        >
        <template v-if="isDesktop">
          <router-link
            :to="$options.filters.productUrlReview(product)"
            :title="product.name"
            class="product__name"
            @click.native="trackProduct()"
          >
            {{ product.name }}
          </router-link>
        </template>
        <template v-else>
          <router-link
            v-if="product.name"
            :to="$options.filters.productUrlReview(product)"
            :title="product.name"
            class="product__name"
            @click.native="trackProduct()"
          >
            {{ product.name }}
          </router-link>
        </template>

        <div v-if="finalPrice && !hidePrice">
          <p v-if="discount && priceBeforeDiscount && priceBeforeDiscount !== finalPrice" class="product-price__stroke">
            {{ formatPrice(priceBeforeDiscount) }}
          </p>
          <p :class="priceBeforeDiscount && discount ? 'product__discount' : 'product__final-price'">
            {{ formatPrice(finalPrice) }}
          </p>
          <p v-if="discount && priceBeforeDiscount" class="product__discount__small">{{ formatPrice(discount) }}</p>
        </div>

        <div v-if="section == 'navbar'" class="product__name bolder">
          {{ formatPrice(finalPrice) }}
        </div>
        <template v-if="section == 'navbar'">
          <div class="product__rating">
            <img src="/assets/img/revamp/star-filled.svg" alt="star" />
            <span>{{ reviewAverageRating }}</span>
          </div>
        </template>
        <GRatingInline
          v-if="!hideTotalReviews && totalReview"
          :average-rating="reviewAverageRating"
          :inline-reviewers="inlineReviewers ? totalReview : false"
          :star-fill-number="isRelatedProduct ? reviewStarFillNumber : 10"
          :total-stars="isRelatedProduct ? undefined : 1"
          :is-inline-review-count="classModifier.length ? true : false"
        />
        <template v-if="!hideTotalReviews && totalReview && !inlineReviewers">
          <p class="product__total-review">({{ $options.filters.cnvrtNumberToK(totalReview) }})</p>
        </template>
        <template v-if="rightBtnReview">
          <template v-if="!productExistsInSociolla">
            <!-- <a href="" class="btn btn-dark product__button-add-review" v-if="isLogin" @click.prevent="selectProduct">Add review</a>
							<a href="" class="btn btn-dark product__button-add-review" @click.prevent="openLoginOtf" v-else>Add review</a> -->
          </template>
        </template>
      </div>
    </div>
    <!-- </router-link> -->
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
export default {
  name: 'Product',
  props: {
    hideTotalReviews: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideCombinations: {
      type: Boolean,
      default: false,
    },
    hideAverageRating: {
      type: Boolean,
      required: false,
      default: false,
    },
    rightBtnReview: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonReview: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonShop: {
      type: Boolean,
      required: false,
      default: false,
    },
    product: {
      type: Object,
      required: false,
      default: () => {},
    },
    classModifier: {
      type: String,
      required: false,
      default: '',
    },
    inlineReviewers: {
      type: Boolean,
      required: false,
    },
    section: {
      required: false,
      type: String,
      default: '',
    },
    hidePrice: {
      type: Boolean,
      required: false,
      default: false,
    },
    objectType: {
      type: String,
      required: false,
      default: '',
    },
    isRelatedProduct: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      updatedProduct: this.product,
    };
  },
  computed: {
    hasCombinations() {
      return Object.values(this.combination).some((comb) => comb.length > 0);
    },
    imageCover() {
      return this.product.images.find((e) => e.is_cover) || this.product.images[0];
    },
    availableStock() {
      let stockFlag = false;
      if (this.product.combinations) {
        for (let i = 0; i < this.product.combinations.length; i++) {
          if (this.product.combinations[i]['stock'] > 0) {
            stockFlag = true;
          }
        }
      }
      return (
        stockFlag || this.product.is_in_stock_lulla || this.product.is_in_stock_sociolla || this.product.is_in_stock
      );
    },
    discount() {
      if (this.product.discount_range) {
        return this.product.discount_range;
      }
      if (this.product.discount_type === 'amount') {
        return `-Rp ${this.$options.filters.currency(this.product.discount)}`;
      } else if (this.product.discount_type === 'percentage') {
        return `-${this.product.discount}%`;
      } else {
        return null;
      }
    },
    labelDiscount() {
      if (this.product.discount_type === 'amount') {
        return `SALE`;
      } else if (this.product.discount_type === 'percentage') {
        return `${this.product.discount}%`;
      } else {
        return null;
      }
    },
    savedProductActive() {
      return this.product.has_bookmarked || this.product.wishlist_product;
    },
    isShopNowActive() {
      return (
        this.product.url_sociolla &&
        this.product.available_for_order &&
        this.product.active &&
        this.product.my_sociolla_sql_id &&
        this.product.product_stock
      );
    },
    discountAmount() {
      if (this.product.discount_type && this.product.discount_type === 'amount') {
        return `-Rp. ${this.$options.filters.currency(this.product.discount)}`;
      } else if (this.product.discount_type && this.product.discount_type === 'percentage') {
        return `-${this.product.discount}%`;
      } else {
        return null;
      }
    },
    priceBeforeDiscount() {
      if (
        this.product.discount_type &&
        this.product.price_after_discount &&
        this.product.price_after_discount < this.product.price
      ) {
        if (this.product.price_range) {
          return this.product.price_range;
        } else {
          return `Rp ${this.$options.filters.currency(this.product.price)}`;
        }
      } else {
        return null;
      }
    },
    showingRangePrice() {
      return (
        Boolean(this.product.min_price) &&
        Boolean(this.product.max_price) &&
        this.product.min_price !== this.product.max_price
      );
    },
    finalPrice() {
      if (this.section === 'search' || this.section === 'navbar') {
        if (this.product.available_for_order && this.product.active && this.product.my_sociolla_sql_id) {
          if (
            this.product.price_after_discount_range &&
            this.product.price_after_discount_range !== ' - ' &&
            this.product.price_after_discount_range !== 0
          ) {
            return this.product.price_after_discount_range;
          }
          if (this.showingRangePrice) {
            return `Rp ${this.$options.filters.currency(this.product.min_price)} - Rp ${this.$options.filters.currency(
              this.product.max_price
            )}`;
          } else {
            if (
              this.product.price_after_discount < this.product.price &&
              this.product.price_after_discount &&
              this.product.discount_type
            ) {
              return `Rp ${this.$options.filters.currency(this.product.price_after_discount)}`;
            } else {
              if (this.product.price !== 0) {
                return `Rp ${this.$options.filters.currency(this.product.price)}`;
              } else {
                return null;
              }
            }
          }
        } else if (this.product.price_range && this.product.price_range !== ' - ' && this.product.price_range !== 0) {
          return this.product.price_range;
        } else if (this.product.combinations && this.product.my_sociolla_sql_id) {
          if (this.product.combinations[0].price && this.product.combinations[0].price != null) {
            return `Rp ${this.$options.filters.currency(this.product.combinations[0].price)}`;
          } else {
            return '-';
          }
        } else {
          return null;
        }
      } else {
        if (this.product.available_for_order && this.product.active && this.product.my_sociolla_sql_id) {
          if (
            this.product.price_after_discount_range &&
            this.product.price_after_discount_range !== ' - ' &&
            this.product.price_after_discount_range !== 0
          ) {
            return this.product.price_after_discount_range;
          }
          if (this.showingRangePrice) {
            return `Rp ${this.$options.filters.currency(this.product.min_price)} - Rp ${this.$options.filters.currency(
              this.product.max_price
            )}`;
          } else {
            if (
              this.product.price_after_discount < this.product.price &&
              this.product.price_after_discount &&
              this.product.discount_type
            ) {
              return `Rp ${this.$options.filters.currency(this.product.price_after_discount)}`;
            } else {
              if (this.product.price !== 0) {
                return `Rp ${this.$options.filters.currency(this.product.price)}`;
              } else {
                return null;
              }
            }
          }
        } else {
          return null;
        }
      }
    },
    totalReview() {
      if (this.product.review_stats && this.product.review_stats.total_reviews) {
        return this.product.review_stats.total_reviews ? this.product.review_stats.total_reviews : 0;
      } else {
        return this.product.total_reviews ? this.product.total_reviews : 0;
      }
    },
    brandNameSlug() {
      return this.product && this.product.brand ? this.$options.filters.slug(this.product.brand.name) : '';
    },
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    productExistsInSociolla() {
      return this.product.is_active_in_sociolla || this.product.is_active_in_lulla;
    },
    productName() {
      // if (this.product.name && this.product.name.length > 38) {
      //   return `${this.product.name.slice(0, 25)}...`;
      // } else {
      //   return this.product.name;
      // }
      return this.product.name;
    },
    productNameSlug() {
      return this.$options.filters.slug(this.product.name);
    },
    reviewAverageRating() {
      if (!this.hideAverageRating) {
        if (this.product.review_stats) {
          const rating = this.$options.filters.productrating(
            Number.parseFloat(this.product.review_stats.average_rating || '0.0')
          );
          if (rating == '0') {
            return '0.0';
          }
          return rating;
        }
      }
      return null;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    reviewStarFillNumber() {
      if (this.product.review_stats) {
        return this.$options.filters.productrating(this.product.review_stats.average_rating) * 10;
      }
    },
    // wishlistSrcUrl () {
    // 	if ( this.product.wishlist_product || this.product.has_bookmarked ) {
    // 		return `/assets/img/icons/icons-wishlist-active.svg`
    //  	}
    //  	else {
    //  		return `/assets/img/icons/icons-wishlist.svg`
    //  	}
    // },
    wishlistSrcUrlV2() {
      const combinationIndex =
        this.updatedProduct &&
        this.updatedProduct.combinations &&
        this.updatedProduct.combinations.findIndex((row) => row.is_default);
      if (
        this.updatedProduct.combinations[combinationIndex] &&
        this.updatedProduct.combinations[combinationIndex].is_wishlist
      ) {
        return `/assets/img/icons/icons-wishlist-active.svg`;
      } else {
        return `/assets/img/icons/icons-wishlist.svg`;
      }
    },
    isWishlist() {
      return this.product.wishlist_product;
    },
    isReviewedButton() {
      return this.product.is_reviewed || this.product.is_reviewed_combination;
    },
    combination() {
      const combinations = this.product.combinations || [];

      return {
        shades: combinations
          .map((e) => (e.attributes && e.attributes.shade ? e.attributes.shade : null))
          .filter(Boolean),
        sizes: combinations.map((e) => (e.attributes && e.attributes.size ? e.attributes.size : null)).filter(Boolean),
        variants: combinations
          .map((e) => (e.attributes && e.attributes.variant ? e.attributes.variant : null))
          .filter(Boolean),
      };
    },
    isDoubleCombination() {
      return (
        Object.values(this.combination)
          .map((e) => e.length)
          .filter(Boolean).length > 1
      );
    },
  },
  methods: {
    internalTrack(verb, objectType) {
      try {
        const payload = {
          verb,
          object_id: this.product.id,
          object_type,
          referrer: {
            object_type: this.objectType,
          },
          target: {
            id: this.product.id,
            object_type: 'product_detail',
          },
        };
        if (this.$route.name == 'BrandDetail') {
          payload.referrer.id = this.product.brand.id;
        }
        if (this.$route.name == 'Category') {
          let id = this.product.default_category.id;
          if (
            this.$route.params.category_id != this.product.default_category.my_soco_sql_id &&
            this.product.categories &&
            this.product.categories.length &&
            this.product.categories.find((res) => res.my_soco_sql_id == this.$route.params.category_id)
          ) {
            id = this.product.categories.find((res) => res.my_soco_sql_id == this.$route.params.category_id).id;
          }
          payload.referrer.id = id;
        }
        this.$store.dispatch('$_InternalTracking/track', payload);
      } catch (err) {
        console.error(err);
      }
    },
    formatPrice(price) {
      if (price.includes('-')) {
        // Handle price range
        const formattedPrice = price.split('-').map((part) => part.trim().replace(' ', ''));
        return formattedPrice.join(' - ');
      } else {
        // Handle single price
        return price.trim().replace(' ', '');
      }
    },
    trackProduct() {
      window.dataLayer.push({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: { list: this.section },
            products: [
              {
                name: this.product.name,
                id: this.product.id,
              },
            ],
          },
        },
      });
    },
    mainImage(src) {
      const urlDummy = '/assets/img/dummy_product.svg';
      if (src.indexOf('http') > -1) {
        if (this.classModifier === 'product--inline' || this.classModifier === 'product--inline-navbar') {
          return this.$options.filters.imageCdn({
            config: 'w=72',
            image: src,
          });
        } else if (this.classModifier === 'product--inline product--inline-minimalist') {
          return this.$options.filters.imageCdn({
            config: this.isDesktop ? 'w=90' : 'w=84',
            image: src,
          });
        } else if (this.classModifier === 'product--minimalist') {
          return this.$options.filters.imageCdn({
            config: 'w=100',
            image: src,
          });
        } else {
          return this.$options.filters.imageCdn({
            config: this.isDesktop ? 'w=169' : 'w=112',
            image: src,
          });
        }
      } else {
        return urlDummy;
      }
    },
    convertName(title) {
      let name = title;
      const word_length = 30;

      if (name.toString().length >= word_length) {
        name = name.toString().substr(0, word_length) + '...';
      }
      return name;
    },
    toggleWhishListV2() {
      if (this.$store.state.auth.loggedin) {
        // if ('is_wishlist' in this.product.default_combination) {
        this.addWhishListV2();
        this.$emit('updatedProduct', this.updatedProduct);
        // }
      } else {
        this.openLoginOtf();
      }
    },
    addWhishListV2() {
      const combinationIndex = this.updatedProduct.combinations.findIndex((row) => row.is_default);
      const currentWishlistStatus = this.updatedProduct.combinations[combinationIndex].is_wishlist;

      this.$MS_CATALOG_API_URL
        .post('/v3/users/me/wishlists', {
          product_id: Number(this.updatedProduct.id),
          product_combination_id: this.updatedProduct.combinations[combinationIndex]._id,
        })
        .then((res) => {
          if (res.status == 200 && res.data.data) {
            this.$toasted.global.show(
              res.data.data.is_wishlisted ? 'Sukses menambahkan ke Wishlist.' : 'Wishlist berhasil dihapus.'
            );
            this.updatedProduct.combinations[combinationIndex].is_wishlist = res.data.data.is_wishlisted;
          } else {
            this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            this.updatedProduct.combinations[combinationIndex].is_wishlist = currentWishlistStatus;
          }
        })
        .catch((error) => {
          this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
          this.updatedProduct.combinations[combinationIndex].is_wishlist = currentWishlistStatus;
        });
    },
    deleteWishlistV2() {
      this.updatedProduct.default_combination.is_wishlist = false;
      return this.$MS_CATALOG_API_URL
        .post('/v3/users/me/wishlists', {
          product_id: Number(this.product.id),
          product_combination_id: this.product.default_combination._id,
        })
        .then((response) => {
          if (response.status == '200' && response.data.data) {
            this.$toasted.global.show('Wishlist berhasil dihapus.');
          } else {
            this.updatedProduct.default_combination.is_wishlist = true;
            this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
          }
        })
        .catch((error) => {
          this.updatedProduct.default_combination.is_wishlist = true;
          this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
        });
    },
    addToWishlist() {
      /* eslint-disable vue/no-mutating-props */
      if (!this.product.wishlist_product) {
        if (this.section === 'search') {
          this.toggleWishlist();
          axios
            .post(Config.MS_CATALOG_API_URL + '/v3/users/me/wishlists', {
              product_id: Number(this.product.id),
              product_combination_id: this.product.default_combination._id,
            })
            .then((res) => {
              if (res.status == 200 && res.data.data) {
                this.$toasted.global.show('Sukses menambahkan ke Wishlist.');
              } else {
                this.product.wishlist_product = false;
              }
            })
            .catch((error) => {
              this.product.wishlist_product = false;
            });
        } else {
          const payload = {
            id_product: this.product.my_sociolla_sql_id,
            id_product_attribute: this.product.id_default_product_attribute,
            my_sociolla_sql_id: this.product.my_sociolla_sql_id,
          };
          this.$MS_SOCO_PUBLIC_API_URL
            .post(`/wishlists`, payload)
            .then((res) => {
              if (res.status == 200) {
                this.$toasted.global.show('Added to wishlist');
                this.product.id_wishlist_product = res.data.data.wishlist.id_wishlist_product;
                this.product.wishlist_product = true;
              } else {
                this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                this.toggleWishlist();
              }
            })
            .catch((error) => {
              this.toggleWishlist();
              this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            });
        }
      } else {
        if (this.section === 'search') {
          this.toggleWishlist();
          return axios
            .post(Config.MS_CATALOG_API_URL + '/v3/users/me/wishlists', {
              product_id: Number(this.product.id),
              product_combination_id: this.product.default_combination._id,
            })
            .then((response) => {
              if (response.status == '200' && response.data.data) {
                this.$toasted.global.show('Wishlist berhasil dihapus.');
              } else {
                this.product.wishlist_product = true;
                this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
              }
            })
            .catch((error) => {
              this.product.wishlist_product = true;
              this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            });
        } else {
          this.$MS_SOCO_PUBLIC_API_URL
            .delete(`wishlists/${this.product.id_wishlist_product}`)
            .then((response) => {
              if (response.status == '200' && response.data.data) {
                this.$toasted.global.show('Wishlist berhasil didelete.');
                this.product.wishlist_product = false;
              } else {
                this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
              }
            })
            .catch((error) => {
              this.toggleWishlist();
              this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            });
        }
      }
      /* eslint-enable vue/no-mutating-props */
    },
    bookmark() {
      // eslint-disable-next-line vue/no-mutating-props
      this.product.has_bookmarked = !this.product.has_bookmarked;
      this.$MS_SOCO_PUBLIC_API_URL
        .post(`/product/${this.product.id}/bookmarks`)
        .then((res) => {
          if (res.status !== 200) {
            throw { res };
            // this.product.has_bookmarked = !this.product.has_bookmarked;
          }
        })
        .catch((err) => {
          console.error(err);
          // eslint-disable-next-line vue/no-mutating-props
          this.product.has_bookmarked = !this.product.has_bookmarked;
        });
    },
    // savedProduct(){
    // 	if (this.$store.state.auth.loggedin) {
    // 		if (this.product.has_bookmarked && this.product.wishlist_product) {
    // 			this.addToWishlist()
    // 			this.bookmark()
    // 		}
    // 		else {
    // 			if (this.product.has_bookmarked) {
    // 				this.bookmark()
    // 			}
    // 			else {
    // 				this.addToWishlist()
    // 			}
    // 		}
    // 	} else {
    // 		this.openLoginOtf()
    // 	}
    // },
    openLoginOtf() {
      this.$store.commit('setDataModal', {
        modalName: 'loginPage',
        value: 1,
      });
    },
    selectProduct(verb, objectType) {
      this.internalTrack(verb, objectType);
      const notInReviewPage = !/review[/]add/.test(this.$route.path);

      if (notInReviewPage && this.product.is_reviewed != true) {
        // this.$router.push({ path: `/review/add/${this.product['id']}`, query: {combination_id: this.product.default_combination._id } })
        this.$router.push(`/review/add/${this.product['id']}`);
      } else {
        this.$toasted.global.error('Kamu sudah membuat review untuk produk ini.');
      }
      this.$store.dispatch('setDataSelectedProduct', { dataSelectedProduct: this.product, component: this });
    },
    toggleWishlist() {
      // eslint-disable-next-line vue/no-mutating-props
      this.product.wishlist_product = !this.product.wishlist_product;
    },
    productUrl(item) {
      let productLink = this.$options.filters.productLinkV3(item);
      if (
        item.default_combination &&
        item.default_combination.attributes &&
        !item.default_combination.attributes.non_specify
      ) {
        const { attributes } = item.default_combination;
        const keys = Object.keys(attributes || {});
        if (keys.length && keys[0] && attributes[keys[0]] && attributes[keys[0]]['name']) {
          productLink += '?';
          keys.forEach(
            (key, idx) =>
              (productLink += `${key}=${this.$options.filters.slug(attributes[key]['name'], '_')}${
                idx < keys.length - 1 ? '&' : ''
              }`)
          );
        }
      }
      return productLink;
    },
    addReviewUrl(product, verb, objectType) {
      this.internalTrack(verb, objectType);
      if (this.isLogin) {
        this.$router.push({
          name: 'WriteReview',
          params: { product_id: product.id },
        });
      } else {
        this.$store.commit('setRedirectURL', { name: 'WriteReview', params: { product_id: product.id } });
        this.openLoginOtf();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bolder {
  font-weight: 700 !important;
}
.layer-link {
  position: absolute;
  width: calc(100% - 20px);
  height: calc(100% - 15px);
  z-index: 1;
}
.product__button-review.sold-out {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border: 0 !important;
  top: 56px !important;
  opacity: 0.64 !important;
  color: #ffffff !important;

  @media (max-width: 991px) {
    letter-spacing: 1px;
    z-index: 2;
  }
}
.btn-mobile {
  width: 100% !important;
}
.btn-black {
  border: solid 1px #231f20 !important;
  color: #231f20 !important;
}

.btn-reviewed {
  background-color: #e5e5e5 !important;
  color: #fff !important;
}
.product__thumbnail {
  position: relative;
  display: flex;
  justify-content: center;
  width: 183px;
  height: 183px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  @media (max-width: 991px) {
    width: 150px;
    height: 150px;
  }
}
.product__thumb {
  img {
    object-fit: contain;
  }
  .product__img {
    width: 100%;
  }
}
</style>
